import sections from '../../utils/theme-sections';
import openModal from '../../components/INF-Modal/openModal';
import { initProductCarousels } from '../../sections/INF-ProductOverview/carousel';

export default (
  product_url,
  init_count,
  list_name,
  cart_edit_item_enabled = false,
  previous_variant_id = null,
  previous_variant_quantity = null,
) => {
  let ajax_url;
  let new_url = product_url.split('#');
  new_url = new_url[0];

  ajax_url = product_url.includes('?') ? `${new_url}&view=ajax` : `${new_url}?view=ajax`;

  const modal = document.getElementById('QuickView');
  const quickViewContent = document.querySelector('[data-quick-view-content]');

  modal.classList.add('QuickView--loading');

  // Only empty the modal immediately if it's not already open
  if (!modal.classList.contains('Modal--open')) {
    quickViewContent.innerHTML = '';
  }

  openModal(modal);

  fetch(ajax_url)
    .then((response) => response.text())
    .then((response) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = response;

      // When the quick view modal is opened in the cart page, this parameter will be true
      // This will enable a serie of changes to the quick view modal
      if (cart_edit_item_enabled) {
        // Add Title heading
        const cartEditHeading = document.createElement('h1');
        cartEditHeading.classList.add('CartEditItem__title');
        cartEditHeading.textContent = 'Edit Your Item';
        tempDiv
          .querySelector('[data-quick-view-container]')
          .insertBefore(cartEditHeading, tempDiv.querySelector('#shopify-section-INF-ProductOverview'));

        // Replace amount X% off with any promo product messaging
        const promoMessage = tempDiv.querySelector('.ProductHeading__promo_message');
        const discountLabel = tempDiv.querySelector('.ProductHeading__discount');

        if (promoMessage && discountLabel) {
          discountLabel.innerHTML = promoMessage.innerHTML;
        }

        // Replace button label with 'UPDATE NOW' when quick view modal is openend in the cart page
        const addToBagButtonPod = tempDiv.querySelector('.ProductInfo__add-to-cart');
        const addToBagButton = tempDiv.querySelector('.ProductInfo__add-to-cart>button');
        addToBagButton.setAttribute('data-edit-cart-item', 'true');
        addToBagButton.name = 'edit';
        addToBagButton.title = 'Edit Cart Item';
        addToBagButton.removeAttribute('data-add-to-cart');
        addToBagButton.innerHTML = '<span data-edit-cart-item-text>Update Now</span>';

        // if the item is sold out, disable any interaction with the button and its container
        if (addToBagButton.disabled) {
          addToBagButtonPod.setAttribute('data-edit-cart-item', false);
          addToBagButton.setAttribute('data-edit-cart-item', false);
          addToBagButton.innerHTML = '<span data-edit-cart-item-text>Sold Out</span>';
        }

        // Replace form action with '/cart/update' when quick view modal is opened in the cart page
        // Set extra attributes like 'previous-variant-id' and 'previous-variant-quantity
        const formAddToBag = tempDiv.querySelector('.ProductInfo__form');
        const inputPreviousVariantId = document.createElement('input');
        const inputPreviousVariantQuantity = document.createElement('input');

        formAddToBag.setAttribute('data-edit-cart-item', 'true');
        inputPreviousVariantId.type = 'hidden';
        inputPreviousVariantId.setAttribute('name', 'previous-variant-id');
        inputPreviousVariantId.setAttribute('value', previous_variant_id);
        formAddToBag.appendChild(inputPreviousVariantId);
        inputPreviousVariantQuantity.type = 'hidden';
        inputPreviousVariantQuantity.setAttribute('name', 'previous-variant-quantity');
        inputPreviousVariantQuantity.setAttribute('value', previous_variant_quantity);
        formAddToBag.appendChild(inputPreviousVariantQuantity);

        // Replace View Details text content with 'View Full Details'
        const viewDetailsLink = tempDiv.querySelector('.ProductInfo__view-details');
        viewDetailsLink.innerHTML = 'View Full Details';

        // It goes off exclusively in cart page for mobile devices.
        // This would fix issue swiper images on iOS devices. It will include Android devices as well
        const imgArr = tempDiv.querySelectorAll('.swiper-main .ProductImages__image.lazyload');
        if (window.innerWidth < 767) {
          imgArr.forEach((img) => {
            img.src = img.dataset.src;
          });
        }
      }

      const product = tempDiv.querySelector('[data-quick-view-container]');
      const productJson = tempDiv.querySelector('[data-product-json]');

      // Remove any special animation classes and replace them with a simple fade-in
      product.querySelectorAll('.Animate, .AnimateOnLoad').forEach((el) => {
        el.className = el.className.replace(/(^|\s)Animate--\S+/g, '');
        el.classList.add('Animate--fade-in');
      });

      // Make the title a link
      const productTitle = product.querySelector('.ProductHeading__title');
      if (productTitle) {
        const titleText = productTitle.textContent;
        productTitle.innerHTML = `<a href="${product_url}" data-quickview-ignore>${titleText}</a>`;
      }

      product.setAttribute('data-collection', list_name);

      quickViewContent.innerHTML = '';
      quickViewContent.appendChild(product);
      quickViewContent.appendChild(productJson);

      sections
        .getInstances('product')
        .then((instances) => {
          instances.forEach((instance) => {
            instance.trigger('section_load');
          });
        })
        .catch((err) => {
          console.error('Quickview error:', err);
        });

      const productImages = quickViewContent.querySelector('[data-product-images]');
      if (productImages) {
        productImages.id = `ProductCarousels${init_count}`;
        productImages.setAttribute('quick-view-carousel', true);

        const thumbs = quickViewContent.querySelector('#ProductCarousel-Thumbs');
        if (thumbs) {
          thumbs.setAttribute('data-as-nav-for', `#ProductCarousels${init_count}`);
          thumbs.id = `ProductCarousel-Thumbs${init_count}`;
        }

        const thumbCount = quickViewContent.querySelector('[data-thumb-count]');
        if (thumbCount) {
          thumbCount.setAttribute('data-thumb-count', init_count);
        }
        if (window.theme.breakpoints.current === 'mobile') {
          const quickViewMobile = document.querySelector('[data-quick-view-content] [data-quick-view-container]');
          if (quickViewMobile) {
            quickViewMobile.setAttribute('data-quickview-mobile', true);
          }
          const viewDetailsMobile = document.querySelector('.ProductInfo__view-details');
          if (viewDetailsMobile) {
            viewDetailsMobile.innerText = 'View Full Product Details';

            if (cart_edit_item_enabled) {
              viewDetailsMobile.innerText = 'View Full Details';
            }
          }
        }
      }

      // Trigger a custom event
      const event = new Event('shouldProcessProductData');
      document.dispatchEvent(event);

      initProductCarousels();

      // Ensure the right image is displayed
      document.addEventListener('DOMContentLoaded', () => {
        const selectedVariant = document.querySelector(
          '[data-product-info-container] .ProductOption__variant--selected',
        );
        if (selectedVariant) {
          selectedVariant.click();
        }
      });

      // Delay to smooth out the animations
      setTimeout(() => {
        modal.classList.remove('QuickView--loading');
        openModal(modal);
      }, 100);
    })
    .catch((error) => {
      console.error('Error fetching the AJAX URL:', error);
    });
};
